import Pagination from "../../components/Pagination/Pagination"
import Filters from "../../components/Filters/Filters"
import InstantSearchWrapper from "../../components/layout/Search/InstantSearchWrapper"
import MainHits from "../../components/Hits/MainHits"
import Search from "../../components/Search/Search"

interface FinishCategoryProps {
    indexName: string;
    categoryPage: string;
}

export default function LaminateCategoryPage({ indexName, categoryPage }: FinishCategoryProps) {
    return (
        <div className="fl-container__flex fl-container__flex--gap">
            <div className={"fl-container__content fl-container__flex fl-container__flex--gap"} style={{ marginTop: "20px", marginBottom: "20px" }}>
                <InstantSearchWrapper indexName={indexName} categoryPage={categoryPage}>
                    <Search />
                </InstantSearchWrapper>
                <InstantSearchWrapper indexName={indexName} categoryPage={categoryPage}>
                    <Filters />
                    <MainHits />
                    <Pagination />
                </InstantSearchWrapper>
            </div>
        </div>
    )
}